interface EmptyStateProps {
  title: string;
  description: string;
  onReset?: () => void;
  resetLabel?: string;
}

export default function EmptyState({ title, description, onReset, resetLabel = "重置筛选" }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 rounded-lg border border-dashed border-background-300 bg-background-100/50">
      <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-200 mb-4">
        <i className="ri-inbox-archive-line text-2xl text-foreground-500" />
      </div>
      <h3 className="font-heading text-lg text-foreground-900">{title}</h3>
      <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>
      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="mt-5 inline-flex items-center gap-2 rounded-md bg-accent-500 px-4 py-2 text-sm font-label text-background-50 hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line" />
          {resetLabel}
        </button>
      )}
    </div>
  );
}